import { GenericService } from './generic.service';
import { ExternalPatientReferenceType } from '@/models';

export class ExternalPatientReferenceTypeService extends GenericService<ExternalPatientReferenceType> {
  endpoint = 'v1/external-patient-reference-types';
}
